import * as Comlink from "comlink";

import type { WorkerApi } from "@/db/worker";

const worker = new Worker(new URL("./worker.ts", import.meta.url), { type: "module" });
const api = Comlink.wrap<WorkerApi>(worker);
const initPromise = api.init();

// Release OPFS SAHPool handles on page unload to prevent the next worker from
// spinning in a tight retry loop (~24s of 100% CPU).
const cleanup = () => worker.terminate();
addEventListener("beforeunload", cleanup);
addEventListener("pagehide", cleanup);

export { api, initPromise };
